module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<legend>'+
((__t=( i18n.tc("VehicleEdit", "Enter vehicle information") ))==null?'':__t)+
'</legend><fieldset><div><label for="automotive-type-input"><span class="error">*</span>'+
((__t=( i18n.tc("VehicleEdit", "Type:") ))==null?'':__t)+
'</label> <select id="automotive-type-input" data-input="automotive-type" '+
((__t=( ( insuranceBlock ) ? " disabled " : "" ))==null?'':__t)+
' required> ';
 if ( hasUnselectedVehicleType ) { 
__p+=' <option value="">'+
((__t=( i18n.tc("VehicleEdit", "Choose a vehicle type") ))==null?'':__t)+
'</option> ';
 } 
__p+=' </select></div><div><label for="automotive-brand-input"><span class="error">*</span>'+
((__t=( i18n.tc("VehicleEdit", "Brand:") ))==null?'':__t)+
'</label> <input type="text" id="automotive-brand-input" data-input="automotive-brand" value="'+
((__t=( brand ))==null?'':__t)+
'" required></div><div><label for="automotive-model-input"><span class="error">*</span>'+
((__t=( i18n.tc("VehicleEdit", "Model:") ))==null?'':__t)+
'</label> <input type="text" id="automotive-model-input" data-input="automotive-model" value="'+
((__t=( model ))==null?'':__t)+
'" required></div><div><label for="automotive-registration-number-input"><span class="error">*</span>'+
((__t=( i18n.tc("VehicleEdit", "Reg. number:") ))==null?'':__t)+
'</label> <input type="text" id="automotive-registration-number-input" data-input="automotive-registration-number" value="'+
((__t=( registrationNumber ))==null?'':__t)+
'" required></div></fieldset><fieldset><div><label for="automotive-chassis-number-input">'+
((__t=( i18n.tc("VehicleEdit", "Chassis number:") ))==null?'':__t)+
'</label> <input type="text" id="automotive-chassis-number-input" data-input="automotive-chassis-number" value="'+
((__t=( chassisNumber ))==null?'':__t)+
'"></div><div><label for="automotive-year-input">'+
((__t=( i18n.tc("VehicleEdit", "Year:") ))==null?'':__t)+
'</label> <input type="text" id="automotive-year-input" data-input="automotive-year" placeholder="'+
((__t=( i18n.tc("VehicleEdit", "YYYY") ))==null?'':__t)+
'" value="'+
((__t=( registrationYear ))==null?'':__t)+
'"></div><div><label for="automotive-color-input">'+
((__t=( i18n.tc("VehicleEdit", "Color:") ))==null?'':__t)+
'</label> <input type="text" id="automotive-color-input" data-input="automotive-color" value="'+
((__t=( color ))==null?'':__t)+
'"></div> ';
 if ( insuranceBlock ) { 
__p+=' <p class="static info" data-text="text-locked">'+
((__t=( i18n.tc("VehicleEdit", "Some fields are locked by your insurance company.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' </fieldset><div class="button-wrap"><button data-click="automotive-cancel">'+
((__t=( i18n.tc("VehicleEdit", "Cancel") ))==null?'':__t)+
'</button> ';
 if ( context === "vehicle" ) { 
__p+=' <button class="primary" data-click="automotive-submit" disabled="disabled">'+
((__t=( i18n.tc("VehicleEdit", "Save") ))==null?'':__t)+
'</button> ';
 } 
__p+=' ';
 if ( context === "install" ) { 
__p+=' <button class="primary" data-click="automotive-submit" disabled="disabled">'+
((__t=( i18n.tc("VehicleEdit", "Next") ))==null?'':__t)+
'</button> ';
 } 
__p+=' </div><fieldset><small><span class="error">*</span>'+
((__t=( i18n.tc("VehicleEdit", ": Required information") ))==null?'':__t)+
'</small></fieldset>';
}
return __p;
};
